import ntidDirectory from "../data/ntidDirectory.json";

export const getNameForNtid = (value) => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!/^[A-Za-z]{3}[0-9]{5}$/.test(trimmed)) return "";
  const normalized = trimmed.toUpperCase();
  return Object.prototype.hasOwnProperty.call(ntidDirectory, normalized)
    ? ntidDirectory[normalized]
    : "";
};
